import React, {useEffect, useState} from "react";
import {default as BuildingTranslationData} from "./BuildingTranslations";
import {default as OtherTranslationData} from "./OtherTranslations";
import {TranslationContext} from "../../../react/providers/TranslationContext";

export function TranslationProvider({initialLanguage, children}) {
    const [language, setLanguage] = useState<string>(initialLanguage ?? 'en-US');

    useEffect(() => {
        setLanguage(initialLanguage);
    }, [initialLanguage]);

    function translate(key: string, nullOnFailure: boolean = false): string {
        let match: RegExpMatchArray;
        if ((match = key.match(/building_g([0-9]+)/)) !== null) {
            const gid = match[1];
            return BuildingTranslationData[gid][language].replace(/&#39;/g, '\'');
        }
        return OtherTranslationData[key]?.[language] ?? (nullOnFailure ? null : `%% ${key} (${language}) %%`);
    }

    return <TranslationContext.Provider value={{
        language,
        setLanguage,
        translate,
        getTranslator: () => (key: string): string => translate(key),
    }}>
        {children}
    </TranslationContext.Provider>
}
